
class commonHeader {
}
module.exports = commonHeader;
